import React, { useEffect, useState } from 'react'
import { useAuthServices } from '../../services/useFetch';
import { Citas } from '../Agenda/Citas/Citas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export const AgendaAdmin = ({ selectedCompany, setSelectAction }) => {

    const { requestPost } = useAuthServices();

    const [executeConsulta, setExecuteConsulta] = useState(true)
    const [citasList, setCitasList] = useState([])

    const [modalError, setModalError] = useState(false)

    useEffect(() => {
        obtieneListadoCitasService();
    }, [executeConsulta]);


    const obtieneListadoCitasService = async () => {
        const body = {
            idUsuario: selectedCompany.id
        }
        const response = await requestPost(body, 19);
        if (!response.error) {
            const { estado, objeto } = response.data
            if (estado) {
                setCitasList(objeto)
            }
        } else {
            setModalError(true)
        }
    }

    const handleCloseError = () => {
        setModalError(false)
    }

    return (
        <>
            <div className='div-mis-citas-header-admin'>
                <button className="btn-volver-admin" onClick={() => setSelectAction('LISTA_COMPANYS')}>
                    <FontAwesomeIcon icon={faChevronLeft} className="me-2" />Volver
                </button>
                <h4 className="mb-0">Agendamiento de {selectedCompany?.nombres}</h4>
            </div>
            <hr />
            <Citas citasList={citasList} executeConsulta={executeConsulta} setExecuteConsulta={setExecuteConsulta} origen="AGENDA_ADMIN" />
            <Modal isOpen={modalError} onHide={handleCloseError} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>Error de comunicación <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p>Vaya, tenemos algunas dificultades de comunicación en este momento, por favor intenta mas tarde.</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseError}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}